<div class="container margin-top-20">
  <div class="row">
    <div class="col-lg-4 col-md-5 col-sm-12">
      <div class="user-profile-box">
        <div class="header clearfix">
          <h3>{{UserFullName}}</h3>
          <img [src]="ProfileImageUrl" alt="UserName" class="img-fluid profile-img">
        </div>
        <div class="detail clearfix">
          <ul class="my-account-nav">
            <li class="sub-nav-title">Manage Account</li>
            <li><a [routerLink]="'/account/profile'"><i class="sl sl-icon-user"></i> My Profile</a></li>
          </ul>
          <ul class="my-account-nav">
            <li class="sub-nav-title">Manage Listings</li>
            <li><a [routerLink]="'/account/properties'" class="current"><i class="sl sl-icon-docs"></i> My
                Properties</a></li>
            <li><a [routerLink]="'/property/forms/submit'"><i class="sl sl-icon-action-redo"></i> Submit New Property</a></li>
          </ul>
          <ul class="my-account-nav no-border-bottom">
            <li><a [routerLink]="'/account/change-password'"><i class="sl sl-icon-lock"></i> Change Password</a></li>
            <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
          </ul>
        </div>
      </div>
    </div>

    <app-my-properties-listing [ActiveCollection]="ActiveCollection" [PendingCollection]="PendingCollection"
      [RejectedCollection]="RejectedCollection" [SoldCollection]="SoldCollection" [activeProcessed]="activeProcessed"
      [pendingProcessed]="pendingProcessed" [rejectedProcessed]="rejectedProcessed" [soldProcessed]="soldProcessed"
      [IsLoading] = "childLoad"
      (getActiveProperty)="getActiveProperty()" (getPendingProperty)="getPendingProperty()"
      (getRejectedProperty)="getRejectedProperty()"
      (getSoldProperty) = "getSoldProperty()">My Property Listing Page</app-my-properties-listing>

  </div>
</div>
